import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Heading from '@atlaskit/heading';
import { Flex, Stack, xcss } from '@atlaskit/primitives';
var boxStyles = xcss({
  height: "var(--ds-space-800, 64px)",
  marginBottom: 'space.200'
});
var stackStyles = xcss({
  paddingTop: 'space.100',
  paddingBottom: 'space.100',
  paddingLeft: 'space.150',
  paddingRight: 'space.150'
});
var CustomSelectMessage = function CustomSelectMessage(_ref) {
  var icon = _ref.icon,
    message = _ref.message,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Stack, {
    xcss: stackStyles,
    testId: testId,
    alignInline: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    xcss: boxStyles,
    alignItems: "center",
    justifyContent: "center"
  }, icon), /*#__PURE__*/React.createElement(Heading, {
    size: "xsmall"
  }, /*#__PURE__*/React.createElement(FormattedMessage, message)));
};
export default CustomSelectMessage;